var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"funda-switch funda-switch--big",on:{"click":_vm.updateNewsletter}},[_c('input',{attrs:{"type":"checkbox","disabled":""},domProps:{"checked":_vm.newsletter}}),_c('span',{staticClass:"slider round"})])}
var staticRenderFns = []

export { render, staticRenderFns }